import { device } from 'constants/media-query'
import styled from 'styled-components'

export const StyledRedClubContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  @media ${device.desktop} {
  }
`
export const StyledSectionContainer = styled.div`
  @media ${device.desktop} {
    margin-inline: auto;
    text-align: center;
  }
`
export const StyledTabContentTitle = styled.h2`
  display: flex;
  justify-content: space-evenly;
  @media ${device.desktop} {
    margin-top: 0;
  }
`

export const StyledRedClubFanSection = styled.section`
  @media ${device.desktop} {
    width: 100%;
    height: 100%;
    padding: 24px 0px 0px 0px;
    margin: 3px 10px 5px 6px;
  }
`
export const StyledFanAdvantagesContainer = styled.section`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  text-align: center;

  @media ${device.desktop} {
    flex-wrap: unset;
    justify-content: flex-start;
    gap: 64px;
    margin-top: 24px;
  }
`
export const StyledAdvantageImg = styled.img`
  width: 70px;
  height: 70px;
`

export const StyledAdvantageTitle = styled.p`
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  max-width: 139px;
  width: 135px;
  @media ${device.desktop} {
    margin-top: 16px;
    margin-bottom: 0;
    text-align: center;
    min-width: 90px;
  }
`

export const StyledPointsSection = styled.section`
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 584px;
  border-radius: 4px;
  padding: 24px 24px 24px 24px;
  background: linear-gradient(180deg, #fac9c9 0%, #f8e0e0 100%);
  @media ${device.desktop} {
    min-height: 273px;
    width: 100%;
    height: 100%;
    margin: 0px 15px;
    margin-bottom: 20px;
    justify-content: space-around;
  }
`

export const StyledPointsOptionsSection1 = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media ${device.desktop} {
    flex-direction: row;
    gap: 50px;
  }
`
export const StyledPointsOptionsSection2 = styled.section`
  display: flex;
  justify-content: center;
  flex-direction: column;
  @media ${device.desktop} {
    flex-direction: row;
    margin-top: 24px;
    gap: 78px;
  }
`

export const StyledWayOfPointsTitle = styled.p`
  @media ${device.desktop} {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    margin-top: 7px;
    color: #4c4646;
    margin-bottom: 0;
    min-width: max-content;
  }
`
